import { createActions } from "re-reduced";

import {
  AddressType,
  AddressValidated,
  BillEstimate,
  BillEstimatePayload,
  Campaign,
  EligibilityUpdate,
  EvChargerColors,
  GetBundleResponse,
  GetSignUpResponse,
  LeadSourceOptions,
  SelectAddressPayload,
  SignUpResponse,
  UsageType,
  UserChecks,
  UserDetails,
  UserPayment,
  UserProperty,
  UserRewards,
  VerificationPayload,
  VerifyCodeResponse,
  VerifyPhoneStartResponse,
  WindcaveAuthorisation,
  WindcaveTransaction,
} from "./types";

export default createActions("CORE", (create) => ({
  validateAddress: create.asyncAction<AddressValidated, AddressType>(),
  validateICP: create.asyncAction<AddressValidated, string>(),
  selectAddress: create.action<SelectAddressPayload>(),
  setAddress: create.action<AddressType>(),
  updateEligibility: create.action<EligibilityUpdate>(),
  verifyMobile: create.asyncAction<
    VerifyPhoneStartResponse,
    VerificationPayload
  >(),
  verifyCode: create.asyncAction<VerifyCodeResponse, string>(),
  completeRegistration: create.asyncAction<void>(),
  createFlickSignUp: create.asyncAction<SignUpResponse, void, string>(),
  updateFlickSignUp: create.asyncAction<SignUpResponse, void, string>(),
  setFlickUserId: create.action<string>(),
  getFlickSignUp: create.asyncAction<GetSignUpResponse, void, string>(),
  setSelectedProduct: create.action<string>(),
  setCampaignLitres: create.asyncAction<GetBundleResponse, void, string>(),
  setFlickSignUpStateComplete: create.action(),
  setCreationSourceIdentifier: create.action(),
  setCurrentFormStep: create.action<string>(),
  setPartialSignUpDialogState: create.action<boolean>(),
  setPromoCode: create.action<string>(),
  setLeadSource: create.action<LeadSourceOptions>(),
  setUserDetails: create.action<UserDetails>(),
  setUserRewards: create.action<UserRewards>(),
  setUserProperty: create.action<UserProperty>(),
  setUsageType: create.action<UsageType>(),
  setUserPayment: create.action<UserPayment>(),
  setUserChecks: create.action<UserChecks>(),
  setCampaigns: create.action<Campaign[]>(),
  setEvChargerInclusion: create.action<boolean>(),
  setEvChargerColor: create.action<EvChargerColors>(),
  createWindcaveTransaction: create.asyncAction<WindcaveTransaction>(),
  checkSuccessfulAuthorisation: create.asyncAction<WindcaveAuthorisation>(),
  fetchBillingEstimate: create.asyncAction<
    BillEstimate[],
    BillEstimatePayload
  >(),
}));
